(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-logo-strip"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('brand-logo-strip-reveal')) {
  customElements.define('brand-logo-strip-reveal', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bl-track');
      this.shell = this.querySelector('.bl-slider-shell');
      this.items = [...this.querySelectorAll('.bl-item')];
      this.buttons = [...this.querySelectorAll('.bl-arrow')];
      this.controls = this.querySelector('.bl-controls');
      this.counter = this.querySelector('.bl-counter');
      this.mobile = matchMedia('(max-width:749px)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.abort = new AbortController();
      this.seen = new Set();
      this.hovered = false;
      this.dragging = false;
      this.selected = false;
      const signal = this.abort.signal;
      this.addEventListener('click', event => {
        const button = event.target.closest('.bl-arrow');
        if (!button || !this.contains(button)) return;
        this.move(Number(button.dataset.direction));
        this.start();
      }, {signal});
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateControls();
        });
      }, {signal});
      this.track.addEventListener('keydown', event => {
        if (!this.enabled || event.target !== this.track) return;
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
      }, {signal});
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true; this.stop();
      }, {signal});
      this.addEventListener('pointerleave', () => {
        this.hovered = false; this.start();
      }, {signal});
      this.addEventListener('focusin', event => {
        const item = event.target.closest('.bl-item');
        if (item) this.showImmediately(item);
        this.stop();
      }, {signal});
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => { if (this.isConnected) this.start(); });
      }, {signal});
      this.track.addEventListener('pointerdown', () => {
        this.dragging = true; this.stop();
      }, {signal});
      const release = () => {
        if (!this.dragging) return;
        this.dragging = false; this.start();
      };
      window.addEventListener('pointerup', release, {signal});
      window.addEventListener('pointercancel', release, {signal});
      document.addEventListener('visibilitychange', () => this.start(), {signal});
      this.mobile.addEventListener('change', () => {
        this.refresh(); this.setupReveal();
      }, {signal});
      this.reduced.addEventListener('change', () => {
        this.setupReveal(); this.start();
      }, {signal});
      this.addEventListener('animationend', event => {
        if (!event.target.classList.contains('bl-reveal-inner')) return;
        event.target.parentElement.classList.remove('bl-revealing');
      }, {signal});
      document.addEventListener('shopify:block:select', event => {
        const item = this.items.find(node => node.dataset.blockId === String(event.detail?.blockId));
        if (!item) return;
        this.selected = true; this.stop(); this.showImmediately(item);
        if (this.enabled) this.scrollToItem(this.items.indexOf(item), false);
      }, {signal});
      document.addEventListener('shopify:block:deselect', event => {
        if (!this.items.some(node => node.dataset.blockId === String(event.detail?.blockId))) return;
        this.selected = false; this.start();
      }, {signal});
      this.resizeObserver = new ResizeObserver(() => this.refresh());
      this.resizeObserver.observe(this.track);
      this.refresh();
      this.setupReveal();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.resizeObserver?.disconnect();
      this.revealObserver?.disconnect(); this.stop();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.items?.forEach(item => item.classList.remove('bl-pending', 'bl-revealing'));
    }
    setupReveal() {
      this.revealObserver?.disconnect();
      this.items.forEach(item => item.classList.remove('bl-pending', 'bl-revealing'));
      if (this.dataset.animate !== 'true' || this.reduced.matches ||
          (this.mobile.matches && this.dataset.mobileAnimate !== 'true') ||
          !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
      this.revealObserver = new IntersectionObserver(entries => {
        const visible = entries.filter(entry => entry.isIntersecting && !this.seen.has(entry.target))
          .sort((a, b) => {
            const vertical = a.boundingClientRect.top - b.boundingClientRect.top;
            return Math.abs(vertical) > 4 ? vertical : a.boundingClientRect.left - b.boundingClientRect.left;
          });
        visible.forEach((entry, index) => {
          const item = entry.target;
          this.seen.add(item);
          item.style.setProperty('--bl-delay', `${index * Number(this.dataset.stagger || 150)}ms`);
          item.classList.remove('bl-pending');
          item.classList.add('bl-revealing');
          this.revealObserver.unobserve(item);
        });
      }, {threshold:0.15});
      this.items.forEach(item => {
        if (this.seen.has(item)) return;
        item.classList.add('bl-pending');
        this.revealObserver.observe(item);
      });
    }
    showImmediately(item) {
      this.seen.add(item);
      item.classList.remove('bl-pending', 'bl-revealing');
      this.revealObserver?.unobserve(item);
    }
    refresh() {
      this.enabled = (this.mobile.matches ? this.dataset.mobileSlider : this.dataset.desktopSlider) === 'true';
      const styles = getComputedStyle(this);
      this.visible = Math.max(1, parseInt(styles.getPropertyValue(this.mobile.matches ? '--bl-mobile-columns' : '--bl-columns'), 10) || 1);
      this.maxIndex = Math.max(0, this.items.length - this.visible);
      const canSlide = this.enabled && this.maxIndex > 0;
      this.shell.classList.toggle('bl-can-slide', canSlide);
      this.buttons.forEach(button => { button.hidden = !canSlide; });
      if (this.controls) this.controls.hidden = !canSlide;
      this.updateControls(); this.start();
    }
    currentIndex() {
      if (!this.enabled || !this.items.length) return 0;
      const track = this.track.getBoundingClientRect();
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      let closest = 0, distance = Infinity;
      this.items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const delta = Math.abs(rtl ? rect.right - track.right : rect.left - track.left);
        if (delta < distance) { closest = index; distance = delta; }
      });
      return Math.min(closest, this.maxIndex);
    }
    scrollToItem(index, smooth = true) {
      const item = this.items[Math.max(0, Math.min(index, this.maxIndex))];
      if (!item) return;
      const track = this.track.getBoundingClientRect(), rect = item.getBoundingClientRect();
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollBy({left:rtl ? rect.right - track.right : rect.left - track.left, behavior:smooth && !this.reduced.matches ? 'smooth' : 'auto'});
    }
    move(direction) {
      if (!this.enabled || !this.maxIndex) return;
      let next = this.currentIndex() + direction;
      if (this.dataset.loop === 'true') {
        if (next > this.maxIndex) next = 0;
        if (next < 0) next = this.maxIndex;
      }
      this.scrollToItem(next);
    }
    updateControls() {
      const index = this.currentIndex();
      if (this.counter) this.counter.textContent = `${index + 1} / ${this.maxIndex + 1}`;
      this.buttons.forEach(button => {
        button.disabled = this.dataset.loop !== 'true' && (Number(button.dataset.direction) < 0 ? index === 0 : index >= this.maxIndex);
      });
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    start() {
      this.stop();
      if (!this.enabled || !this.maxIndex || this.dataset.autoplay !== 'true' || this.reduced.matches || this.hovered || this.dragging || this.selected || document.hidden || this.contains(document.activeElement) || window.Shopify?.designMode) return;
      this.timer = setInterval(() => {
        if (this.dataset.loop !== 'true' && this.currentIndex() >= this.maxIndex) { this.stop(); return; }
        this.move(1);
      }, Number(this.dataset.interval) || 3000);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const selector = '[data-product-reveal]';
    const init = root => {
      instances.get(root)?.();
      if (root.dataset.productReveal !== 'true') return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduced.matches || !('IntersectionObserver' in window)) return;
      const cards = Array.from(root.querySelectorAll('[data-product-reveal-card]'));
      if (!cards.length) return;
      const duration = Math.max(200, Math.min(1500, Number(root.dataset.revealDuration) || 600));
      const stagger = Math.max(0, Math.min(500, Number(root.dataset.revealStagger) || 0));
      const pending = new Set(cards);
      const timers = new Map();
      let observer;
      const finish = card => {
        window.clearTimeout(timers.get(card));
        timers.delete(card);
        card.classList.remove('product-reveal-pending', 'product-reveal-running');
        card.style.removeProperty('--product-reveal-duration');
        card.style.removeProperty('--product-reveal-delay');
      };
      const reveal = (card, delay) => {
        if (!pending.delete(card)) return;
        observer.unobserve(card);
        card.style.setProperty('--product-reveal-duration', `${duration}ms`);
        card.style.setProperty('--product-reveal-delay', `${delay}ms`);
        card.classList.add('product-reveal-running');
        timers.set(card, window.setTimeout(() => finish(card), duration + delay + 150));
      };
      const onAnimationEnd = event => {
        if (event.animationName === 'horizonProductStaggerReveal' && cards.includes(event.target)) finish(event.target);
      };
      const onFocus = event => {
        const card = event.target.closest('[data-product-reveal-card]');
        if (card && root.contains(card)) {
          pending.delete(card);
          observer.unobserve(card);
          finish(card);
        }
      };
      const cleanup = () => {
        observer?.disconnect();
        pending.clear();
        cards.forEach(finish);
        root.removeEventListener('animationend', onAnimationEnd);
        root.removeEventListener('focusin', onFocus);
        reduced.removeEventListener('change', onPreference);
        instances.delete(root);
      };
      const onPreference = () => { if (reduced.matches) cleanup(); };
      try {
        observer = new IntersectionObserver(entries => {
          entries.filter(entry => entry.isIntersecting && pending.has(entry.target))
            .sort((a, b) => Number(a.target.dataset.revealOrder) - Number(b.target.dataset.revealOrder))
            .forEach((entry, index) => reveal(entry.target, index * stagger));
        }, { threshold: 0.05 });
        root.addEventListener('animationend', onAnimationEnd);
        root.addEventListener('focusin', onFocus);
        reduced.addEventListener('change', onPreference);
        instances.set(root, cleanup);
        cards.forEach(card => {
          card.classList.add('product-reveal-pending');
          observer.observe(card);
        });
      } catch (error) {
        cleanup();
      }
    };
    const scan = scope => {
      if (scope.matches?.(selector)) init(scope);
      scope.querySelectorAll(selector).forEach(init);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
    } else {
      scan(document);
    }
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.matches?.(selector)) instances.get(event.target)?.();
      event.target.querySelectorAll(selector).forEach(root => instances.get(root)?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-highlights"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('service-highlights-reveal')) {
    customElements.define('service-highlights-reveal', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enabled !== 'true' || this.hasRevealed) return;
        if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (this.motionQuery.matches) return;
        this.animations = [];
        this.onMotionChange = (event) => {
          if (event.matches) {
            this.observer?.disconnect();
            this.animations.forEach((animation) => animation.cancel());
          }
        };
        this.motionQuery.addEventListener('change', this.onMotionChange);
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.hasRevealed = true;
          if (this.motionQuery.matches) return;
          const duration = Number(this.dataset.duration) || 600;
          const stagger = Number(this.dataset.stagger) || 0;
          const distance = Number(this.dataset.distance) || 20;
          let transform = 'none';
          if (this.dataset.effect === 'fade_up') transform = `translateY(${distance}px)`;
          if (this.dataset.effect === 'fade_left') transform = `translateX(-${distance}px)`;
          this.animations = Array.from(this.children).map((item, index) => {
            return item.animate([
              { opacity: 0, transform },
              { opacity: 1, transform: 'none' }
            ], {
              duration,
              delay: index * stagger,
              easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)',
              fill: 'backwards'
            });
          });
        }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.animations?.forEach((animation) => animation.cancel());
        if (this.motionQuery && this.onMotionChange) {
          this.motionQuery.removeEventListener('change', this.onMotionChange);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-image-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const selector = '[data-split-entrance]';
    const init = root => {
      instances.get(root)?.();
      if (root.dataset.splitEntrance !== 'true') return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = window.matchMedia('(max-width: 749px)');
      if (reduced.matches || (mobile.matches && root.dataset.entranceMobile !== 'true')) return;
      const inner = root.querySelector('.sb-inner');
      if (!inner) return;
      let observer, timer, started = false;
      const finish = () => {
        observer?.disconnect();
        window.clearTimeout(timer);
        root.classList.remove('sb-entrance-ready', 'sb-entrance-running');
      };
      const cleanup = () => {
        finish();
        inner.removeEventListener('animationend', onEnd);
        root.removeEventListener('focusin', cleanup);
        reduced.removeEventListener('change', onPreference);
        mobile.removeEventListener('change', onPreference);
        instances.delete(root);
      };
      const onEnd = event => {
        if (event.target === inner && event.animationName === 'splitBannerEntrance') cleanup();
      };
      const onPreference = () => {
        if (reduced.matches || (mobile.matches && root.dataset.entranceMobile !== 'true')) cleanup();
      };
      const start = () => {
        if (started) return;
        started = true;
        observer?.disconnect();
        root.classList.add('sb-entrance-running');
        const duration = Math.max(300, Math.min(2000, Number(root.dataset.entranceDuration) || 800));
        const delay = Math.max(0, Math.min(2000, Number(root.dataset.entranceDelay) || 0));
        timer = window.setTimeout(cleanup, duration + delay + 250);
      };
      try {
        inner.addEventListener('animationend', onEnd);
        root.addEventListener('focusin', cleanup);
        reduced.addEventListener('change', onPreference);
        mobile.addEventListener('change', onPreference);
        instances.set(root, cleanup);
        root.classList.add('sb-entrance-ready');
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) start();
          }, { threshold: 0 });
          observer.observe(root);
        } else {
          start();
        }
      } catch (error) {
        cleanup();
      }
    };
    const scan = scope => {
      if (scope.matches?.(selector)) init(scope);
      scope.querySelectorAll(selector).forEach(init);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
    } else {
      scan(document);
    }
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.matches?.(selector)) instances.get(event.target)?.();
      event.target.querySelectorAll(selector).forEach(root => instances.get(root)?.());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
